import { css } from 'styled-components';
import checkedStyle from 'gatsby-theme-core/src/components/form-elements/checkbox/checked-style';

export default css`
  ${checkedStyle};
  border-color: ${({ theme }) => theme.primaryColor};
`;
